import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import CategoryComponent from "./CategoryComponent";
import { normalizeProductCategoryTree } from "./categoryTree";
import { ProductCategory } from "../context/ShoppingCartContext";
import { useAppSelector } from "../../../store/hooks";
import usePageLanguage from "../hooks/usePageLanguage";
import React from "react";
import { getComponentFromStructureMap } from "../utilities/componentIdentity";

interface Props {
  id: number;
  productCategoryUuid: string | null;
  setProductCategoryUuid: (val: string) => void;
  depthLevel?: number;
}

declare var API: any;

const languageTranslations = {
  et: {
    products: "Tooted",
  },
  en: {
    products: "Products",
  },
};

export default function CategoriesComponent({
  id,
  productCategoryUuid,
  setProductCategoryUuid,
  depthLevel = 0,
}: Props) {
  const component = (useAppSelector((state) =>
    getComponentFromStructureMap(state.builder.structure.components, id)
  ) as any) ?? ({
    id: typeof id === "number" ? id : -1,
    parent_id: null,
    childElements: [],
    childWebpageComponentRelations: [],
    sort_order: 0,
    type: "ProductsComponent",
    uuid: null,
    version: 1,
    webpage_id: 0,
    attributes: {
      category_position: "static",
      styles: {},
      classes: "",
      content_width_size: 0,
      content_width_unit: "px",
      typography_id: 0,
    },
  } as any);

  const isBuilder = document.getElementById("BuilderContent");

  const location = useLocation();
  const locale = usePageLanguage();
  const colors = useAppSelector((state) => state.builder.colors);
  var themeColor: any = null;
  const [productCategories, setProductCategories] = useState<ProductCategory[]>(
    []
  );

  useEffect(() => {
    if (location.search.includes("?category=")) {
      setProductCategoryUuid(location.search.split("?category=")[1]);
    }
  }, []);

  if (colors) {
    themeColor = colors.filter((x) => x.name === "SHOPTHEMECOLOR")[0]?.color;
  }

  useEffect(() => {
    const loadCategories = () => {
      if (typeof API !== "undefined") {
        // @ts-ignore
        return window.axios("/productCategories.json", {
          method: "GET",
          cache: "no-cache",
          headers: { "Content-Type": "application/json" },
        })
        .then((res: any) => {
          setProductCategories(normalizeProductCategoryTree(res.data));
        });
      } else {
        return fetch("/webstoreApi/productCategories.json", {
          method: "GET",
          cache: "no-cache",
          headers: { "Content-Type": "application/json" },
        })
          .then((res) => res.json())
          .then((data) => {
            setProductCategories(normalizeProductCategoryTree(data));
          });
      }
    };

    loadCategories();
  }, []);

  return (
    <div
      key={"categories"}
      className="panel categories margin-top-15"
      style={{
        position:
          component.attributes.category_position === "sticky"
            ? "sticky"
            : "relative",
        top:
          component.attributes.category_position === "sticky"
            ? `${
                Number(component.attributes.category_sticky_top) +
                (isBuilder ? 45 : 0)
              }px`
            : "0px",

        height: "fit-content",
        overflow: "scroll",
      }}
    >
      <div className="panel-heading">
        <h5 style={{ color: themeColor }}>
          <a
            href={undefined}
            className="d-block d-md-none cats-title"
            id="cats-title-m"
            data-toggle="collapse"
            style={{ color: themeColor }}
          >
            {languageTranslations[locale]?.products}
          </a>
          <a href={undefined} className="d-none d-md-block cats-title">
            {languageTranslations[locale]?.products}
          </a>
        </h5>
      </div>
      <div className="panel-collapse collapse in show" id="categories">
        <ul>
          {productCategories!.map((productCategory) => {
            return (
              <CategoryComponent
                key={productCategory.uuid}
                depthLevel={depthLevel}
                productCategories={productCategories}
                productCategory={productCategory}
                productCategoryUuid={productCategoryUuid}
                setProductCategoryUuid={setProductCategoryUuid}
              />
            );
          })}
        </ul>
      </div>
    </div>
  );
}
